const SPOKES = Array.from({ length: 24 }, (_, i) => i * 15);

export const IndiaFlag = ({ className = "h-6 w-9", testId = "india-flag" }) => (
  <svg viewBox="0 0 900 600" className={`${className} overflow-hidden rounded-[3px] shadow-[0_1px_3px_rgba(0,0,0,0.18)]`} role="img" aria-label="Flag of India" data-testid={testId}>
    <rect width="900" height="200" fill="#FF9933" />
    <rect y="200" width="900" height="200" fill="#FFFFFF" />
    <rect y="400" width="900" height="200" fill="#138808" />
    <g transform="translate(450 300)" fill="none" stroke="#000080">
      <circle r="92" strokeWidth="9" />
      <circle r="16" fill="#000080" stroke="none" />
      {SPOKES.map((a) => (
        <line key={a} x1="0" y1="0" x2="0" y2="-88" strokeWidth="4" transform={`rotate(${a})`} />
      ))}
      {SPOKES.map((a) => (
        <circle key={`d${a}`} r="6" cy="-88" fill="#000080" stroke="none" transform={`rotate(${a + 7.5})`} />
      ))}
    </g>
    <rect width="900" height="600" fill="none" stroke="rgba(0,0,0,0.08)" strokeWidth="6" />
  </svg>
);
